import { Module } from 'vuex-smart-module';
import ProductActions from './actions';
import ProductGetters from './getters';
import ProductMutations from './mutations';
import { ProductState } from './state';

export default new Module({
  state: ProductState,
  mutations: ProductMutations,
  actions: ProductActions,
  getters: ProductGetters,
});
